import { convertToExportedView } from '@estee/elc-service';
import { CART_SIDEBAR_OFFER_CODE_MODULE } from '@estee/elc-service-view-names';
import { serviceNames } from '~setup/OffersService';
import { IOfferCodeModule } from './OfferCodeModule';

export type INTERFACE = IOfferCodeModule;

// @ts-ignore
export default convertToExportedView<IOfferCodeModule>(
    () => import('./OfferCodeModule'),
    CART_SIDEBAR_OFFER_CODE_MODULE,
    serviceNames.offerCodeModuleViewController
);
